import React from 'react';

import Box from '@atlaskit/primitives/box';
import { xcss } from '@atlaskit/primitives/xcss';

const styles = xcss({
	marginBlockStart: 'space.100',
	marginInline: 'space.negative.300',
	/* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/design-system/no-nested-styles */
	// @ts-expect-error - Remove bottom border on platform tabs via nested style as there's no other way to do this currently
	'nav::before': {
		display: 'none',
	},
	/* eslint-enable @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/design-system/no-nested-styles */
});

const wrapperStyles = xcss({
	gridArea: 'tabs',
	overflowX: 'hidden',
	overflowY: 'hidden',
});

export const Tabs = ({ children }: React.PropsWithChildren<unknown>): React.JSX.Element => {
	return (
		<Box xcss={wrapperStyles}>
			<Box xcss={styles}>{children}</Box>
		</Box>
	);
};
